<script>
export default {
  name: 'BaseTwoWaySticky',
  props: {
    padding: Number,
    topOffset: Number,
  },
  data() {
    return {
      shift: 0,
      lastScrollTop: null,
      state: 'fixed',
    };
  },
  computed: {
    styles() {
      switch (this.state) {
        case 'top':
          return {
            position: 'sticky',
            alignSelf: 'start',
            top: `${this.padding}px`,
          };
        case 'bottom':
          return {
            position: 'sticky',
            alignSelf: 'end',
            bottom: `${this.padding}px`,
          };
        default:
          return {
            translate: `0 ${this.shift}px`,
          };
      }
    },
  },
  mounted() {
    document.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.state = 'top';
    },
    onScroll() {
      const currScrollTop = document.documentElement.scrollTop;

      if (this.lastScrollTop !== null) {
        const isDirectionDown = this.lastScrollTop < currScrollTop;

        this.run(isDirectionDown);
      }

      this.lastScrollTop = currScrollTop;
    },
    run(isDirectionDown) {
      const target = this.$el;
      const parent = target.parentNode;

      const targetPos = target.getBoundingClientRect();
      const parentPos = parent.getBoundingClientRect();

      if (isDirectionDown) {
        if (this.state === 'top') {
          this.state = 'fixed';
          this.shift = (targetPos.top - parentPos.top - 35);
          return;
        }

        const wHeight = document.documentElement.clientHeight;

        if (targetPos.bottom - wHeight + this.padding < 0) {
          this.state = 'bottom';
        }
      } else {
        if (this.state === 'bottom') {
          this.state = 'fixed';
          this.shift = (targetPos.top - parentPos.top - this.topOffset);
          return;
        }

        if (targetPos.y - this.padding > 0) {
          this.state = 'top';
        }
      }
    },
  },
};
</script>

<template lang="pug">
.two-way-sticky(:style="styles")
  slot
</template>
